<template>
  <div>
    <v-card>
      <v-form ref="form" class="multi-col-validation">
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">OFFICE RENTAL</h4>
          </v-toolbar-title>
        </v-toolbar>

        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md12>
            <v-select
              class="mx-2"
              v-model="particulars"
              dense
              outlined
              label="Particulars"
              :items="particulars_items"
              item-value="particulars"
              :rules="rules.combobox_rule"
              @change="initialize_data"
            ></v-select>
          </v-flex>
          <v-flex xs12 md6 v-if="particulars==='New'">
            <v-select
              class="mx-2"
              v-model="months_deposit"
              dense
              outlined
              label="Security Deposit"
              :items="['1 Month Deposit','2 Months Deposit','3 Months Deposit','4 Months Deposit','5 Months Deposit','6 Months Deposit','7 Months Deposit','8 Months Deposit','9 Months Deposit','10 Months Deposit','11 Months Deposit','12 Months Deposit']"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md6 v-if="particulars==='New'">
            <v-text-field
              class="mx-2"
              v-model="description"
              dense
              label="Description"
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12 v-if="particulars!='New'">
            <v-select
              class="mx-2"
              v-model="year"
              dense
              outlined
              label="Year"
              :items="year_items"
              item-value="year"
              item-text="year"
              :rules="rules.combobox_rule"
              @change="selected_year"
            ></v-select>
          </v-flex>
          <v-flex xs12 md6 v-if="particulars!='New'">
            <v-select
              class="mx-2"
              v-model="from_month_of"
              dense
              outlined
              label="From Month Of"
              :items="month_of_items"
              item-value="month_of"
              item-text="month_of"
              :rules="rules.combobox_rule"
              @change="selected_month"
            ></v-select>
          </v-flex>
          <v-flex xs12 md6 v-if="particulars!='New'">
            <v-select
              class="mx-2"
              v-model="to_month_of"
              dense
              outlined
              label="To Month Of"
              :items="month_of_items2"
              item-value="month_of"
              item-text="month_of"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-row>
          <!-- alert -->
          <v-col cols="12" v-show="alert">
            <v-alert
              color="warning"
              text
              class="mb-0"
            >
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{alert_message}}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn
              class="w-full"
              color="primary"
              @click="done_request"
              v-if="!saving_request"
            >
              Done
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>
<script>

  import {mdiAlertOutline} from "@mdi/js";
  import {mapActions, mapGetters} from "vuex";

  const initialState = () => {
    return {
      saving_request: false,
      alert: false,
      alert_message: '',
      particulars: '',
      particulars_items: ['New', 'Existing', 'Increase', 'Extension'],
      year: '',
      year_items: [],
      from_month_of: '',
      month_of_items: [],
      month_of_items2: [],
      to_month_of: '',
      description: '',
      months_deposit: '',
    }
  }
  export default {
    props: {
      branch_id: Number,
      particulars_id: Number,
    },
    setup() {
      return {
        icons: {
          mdiAlertOutline,
        },
      }
    },
    data() {
      return initialState();
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
    },
    mounted() {
      this.initialize_data()
    },
    methods: {
      ...mapActions('request_data', ['check_revolving_fund_availability', 'list_of_year_and_month_of_of_particular_office_rental']),
      initialize_data() {
        this.list_of_year_and_month_of_of_particular_office_rental({
          particulars_id: this.particulars_id,
          branch_id: this.branch_id,
          selection: this.particulars,
        })
          .then(response => {
            this.month_of_items = []
            this.year_items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
      selected_year() {
        var index = this.year_items.map(function (x) {
          return x.year;
        }).indexOf(this.year)
        if (index != -1) {
          this.month_of_items = this.year_items[index].month_of
        }
      },
      selected_month(value) {
        this.month_of_items2 = []
        var index = this.month_of_items.map(function (x) {
          return x;
        }).indexOf(value)
        if (index != -1) {
          for (var x = index; x < this.month_of_items.length; x++) {
            var dataaa = this.month_of_items[x]
            this.month_of_items2.push(dataaa)
          }
        }
      },
      done_request() {
        this.saving_request = true
        this.alert = false
        if (this.$refs.form.validate()) {
          if (this.particulars != 'New') {
            this.$emit('data', this.particulars + ' # From-' + this.from_month_of + ' # To-' + this.to_month_of)
          } else {

            this.$emit('data', this.particulars + ' # Desc.-' + this.months_deposit + ' #- ' + this.description)
          }

          this.saving_request = false
        } else {
          this.alert = true
          this.alert_message = 'Please Fill up the field/s'
          this.saving_request = false
        }
      },
    }
  }
</script>
